import { render, staticRenderFns } from "./PickupPointsView.vue?vue&type=template&id=7abf84cc&"
import script from "./PickupPointsView.vue?vue&type=script&lang=js&"
export * from "./PickupPointsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports